import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dash_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export const login = (username, password) =>
  axios.post(`${API_BASE}/auth/login`, { username, password }).then(r => r.data);

export const fetchSummary = () => api.get("/dashboard/summary").then(r => r.data);
export const fetchProfitBySku = (start, end) =>
  api.get("/profit/by-sku", { params: { start_date: start, end_date: end } }).then(r => r.data);
export const fetchSalesTrend = (months = 6) =>
  api.get("/sales/trend", { params: { months } }).then(r => r.data);
export const fetchInventory = () => api.get("/inventory").then(r => r.data);
export const fetchCosts = () => api.get("/costs").then(r => r.data);
export const saveCost = (data) => api.post("/costs", data).then(r => r.data);
export const fetchSyncLogs = () => api.get("/sync/logs").then(r => r.data);
export const triggerSync = (type, params = {}) =>
  api.post(`/sync/${type}`, null, { params }).then(r => r.data);

export default api;
